import * as React from 'react';
import {useUiConfig} from '../../providers/UiConfigProvider';
import {DrawerDesktop} from './Drawer.desktop';
import {DrawerMobile} from './Drawer.mobile';
import {DrawerConfig} from './DrawerConfig';

export const Drawer = DrawerConfig.createView((props) => {
  const uiConfig = useUiConfig();
  const isSmallScreen = !!uiConfig?.isSmallScreen;
  const isTouch = !!uiConfig?.isTouch;
  const enabledBottomSheets = !!uiConfig?.enableBottomSheets;

  return isTouch && isSmallScreen && enabledBottomSheets ? (
    <DrawerMobile {...props} />
  ) : (
    <DrawerDesktop {...props} />
  );
});
